import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input } from '../../../../Elements';

export default class TextAreaWidget extends React.Component {

  static propTypes = {
    schema: PropTypes.object.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const { value } = this.props;
    return (
      <div>
        <Input
          name='textAreaWidget'
          value={value || ''}
          placeholder='Your answer'
          onChange={this.onChange}
          autoHeight
          rows={2}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Widgets/TextArea.js